import { ReactNode, useRef } from "react";

import { FullScreenPage, FullScreenRouterState } from "@accurx/navigation";
import { LogoutMedicalRecordModal } from "domains/inbox/components/LogoutMedicalRecordModal/LogoutMedicalRecordModal";
import { UnreadsForwarder } from "domains/inbox/components/UnreadsForwarder/UnreadsForwarder";
import { NoNavigationLayout } from "layouts/UnifiedLayout/UnifiedLayout";
import { useHistory, useLocation } from "react-router-dom";

import { StyledPage } from "./FullscreenLayout.styles";

type FullscreenLayoutProps = {
    children: ReactNode;
    header: string;
};

export const FullscreenLayout = ({
    header,
    children,
}: FullscreenLayoutProps) => {
    const history = useHistory();

    const { state } = useLocation<FullScreenRouterState>();

    // Retain the initial state when the full screen page was created
    const fullScreenRouterState = useRef<FullScreenRouterState>(state);

    return (
        <NoNavigationLayout>
            <FullScreenPage
                header={header}
                onClose={() =>
                    history.push(
                        fullScreenRouterState.current?.originLocation ?? "/",
                    )
                }
            >
                <StyledPage>{children}</StyledPage>
            </FullScreenPage>

            <UnreadsForwarder />
            <LogoutMedicalRecordModal />
        </NoNavigationLayout>
    );
};
